import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

export const Container = styled.div`
  width: 100%;
  background: ${select('white')};
  border: 1px solid ${select('neutralDarkGray')};
  border-radius: 8px;
  padding: 16px;
  margin: 24px 0;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      flex-direction: column-reverse;
    `}
`;

export const Content = styled.div`
  flex: 1;
  margin-bottom: 16px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      max-width: 398px;
    `}
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${select('black')};
  margin: 0 0 8px 0;
  line-height: 1.3;
  ${({ device }) =>
    device === 'mobile' &&
    css`
      white-space: break-spaces;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    `}
  ${({ device }) =>
    device === 'tablet' &&
    css`
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    `}
`;

export const Description = styled.p`
  color: ${select('neutralDarkGrayII')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: break-spaces;
  ${({ device }) =>
    (device === 'mobile' || device === 'tablet') &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;

export const LearnMoreLink = styled.a`
  color: ${({ clicked }) => (clicked ? select('violetLight') : select('black'))};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${({ device }) =>
    device === 'mobile' &&
    css`
      justify-content: space-between;
    `}
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${select('black')};
  font-weight: 500;
`;

export const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ checked }) => (checked ? getColor('primary') : select('midNeutralGray'))};
  transition: 0.4s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: ${props => (props.checked ? '23px' : '3px')};
    bottom: 3px;
    background-color: ${select('white')};
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const TokkoLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 28px;

  svg {
    height: 28px;
    width: auto;
  }
`;

export const PercentageContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: center;
`;

export const PercentageOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? select('darkGray') : select('black'))};
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;
  min-height: 24px;
`;

export const RadioButton = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid
    ${({ checked, disabled }) => {
      if (disabled) return select('black');
      if (checked) return getColor('primary');
      return select('black');
    }};
  border-radius: 50%;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  background-color: ${({ checked, disabled }) => {
    if (disabled && checked) return select('neutralGray');
    return select('white');
  }};

  &:hover {
    ${({ disabled }) =>
      !disabled &&
      `
      border-color: ${getColor('primary')};
    `}
    box-shadow: 0 0 0 2px ${select('neutralDarkGray')};
  }

  &:focus {
    outline: none;
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ disabled }) => (disabled ? select('midNeutralGray') : getColor('primary'))};
  }
`;
